<template>
  <div class="body">
    <!-- <div class="heads">
      <form action="1">
        <van-search
          v-model="value"
          placeholder="工程名称、单位工程"
          shape="round"
          @search="onSearch"
        />
      </form>
      <img
        class="type"
        src="@/assets/images/filter.png"
        alt=""
        @click="btn_type"
      >
    </div> -->
    <div class="main">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset='10'
          @load="onLoad"
        >
          <ul>
            <li
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="li_top">
                <img
                  src="@/assets/images/company.png"
                  alt=""
                >
                <div class="title">
                  {{item.projectName}}
                </div>
                <div
                  class="status"
                  :class="`status${item.state}`"
                  v-text="item.state==1?'待提交':index==3?'待验收':index==2?'退回':index==4?'已验收':'待提交'"
                ></div>
              </div>
              <div class="li_content">
                <div class="lebal_item">
                  <div class="lebal">单位工程：</div>
                  <div class="lebal_test">{{item.subProjectName}}...</div>
                </div>
                <div class="lebal_item">
                  <div class="lebal">建设单位：</div>
                  <div class="lebal_test">{{item.buildUnit}}</div>
                </div>
                <div class="lebal_item">
                  <div class="lebal">施工单位：</div>
                  <div class="lebal_test">{{item.constructionUnit}}</div>
                </div>
                <div class="lebal_item">
                  <div class="lebal">验收时间：</div>
                  <div class="lebal_test">{{item.acceptanceDate}}</div>
                </div>
                <div class="footer">
                  <van-button
                    type="info"
                    class="btn_info"
                    :disabled='item.fileUrl.length?false:true'
                    @click="btn_enclosure(item.overAcceptUrl,'附件')"
                  >附件</van-button>
                  <van-button
                    type="info"
                    class="btn_info"
                    @click="btn_detail(item)"
                  >查看详情</van-button>
                </div>
              </div>

            </li>
            <van-empty
              v-if="list.length==0&&finished"
              description="暂无数据"
            />
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { overAcceptList } from "@/request/api";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      value: "",
      pageNum: 0,
      pageSize: 5,
    };
  },
  mounted() {
    if (this.$route.query.projectId) {
      sessionStorage.setItem("projectId", this.$route.query.projectId);
    }
  },
  methods: {
    onLoad(e) {
      setTimeout(() => {
        if (this.refreshing) {
          this.pageNum = 0;
          this.list = [];
          this.refreshing = false;
        }
        this.pageNum++;
        this.getoverAcceptList();
        this.loading = false;
      }, 1000);
    },
    // 下拉刷新
    onRefresh(e) {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    onSearch(e) {
      console.log(this.value);
    },
    // 分类
    btn_type() {
      this.$router.push({ path: "/oneCardAndTwoBooksType" });
    },
    // 附件
    btn_enclosure(url, name) {
      this.$router.push({
        path: "/enclosurePdf",
        query: { url: url, name: name },
      });
    },
    // 详情
    btn_detail(item) {
      this.$router.push({
        path: "/completedDetail",
        query: { item: JSON.stringify(item) },
      });
    },
    async getoverAcceptList(status) {
      const data = {
        projectId:
          sessionStorage.getItem("projectId") || this.$route.query.projectId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      const res = await overAcceptList(data);
      if (res.success) {
        this.list.push(...res.data.list);
        if (!res.data.hasNextPage) {
          this.finished = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  text-align: left;
}
.main {
  // padding-top: 100px;
  ul {
    min-height: calc(100vh - 120px) !important;
    li {
      background-color: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      width: 100%;
      margin-top: 20px;
      .li_top {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        img {
          width: 60px;
          height: 60px;
        }
        .title {
          flex: 1;
          padding-left: 20px;
          box-sizing: border-box;
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #222222;
          line-height: 34px;
        }
        .status {
          width: 120px;
          height: 40px;
          line-height: 40px;
          background: #e6efff;
          border-radius: 20px;
          text-align: center;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #0056e4;
          &.status1 {
            background: #e6efff;
            color: #0056e4;
          }
          &.status4 {
            background: #d0fefc;
            color: #02bbb6;
          }
          &.status2 {
            background: #fedede;
            color: #ff5757;
          }
          &.status3 {
            background: #feecdb;
            color: #fd7e02;
          }
        }
      }
      .li_content {
        width: 100%;
        padding: 20px 0 20px 0;
        position: relative;

        .lebal_item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          margin-bottom: 20px;
          .lebal_test {
            flex: 1;
            color: #666666;
            font-size: 28px;
            display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
            -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
            overflow: hidden; /*超出的文本隐藏*/
            text-overflow: ellipsis; /* 溢出用省略号*/
            -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
          }
        }
      }
      .footer {
        width: 100%;
        text-align: center;
        .btn_info {
          width: 310px;
          height: 70px;
          border-radius: 35px;
          margin: 10px 10px 10px;
        }
      }
    }
  }
}
.heads {
  width: 100%;
  height: 100px;
  background-color: #fff;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
  box-sizing: border-box;
  form {
    flex: 1;
  }
  .type {
    width: 40px;
    height: 40px;
  }
  .van-search__content {
    background-color: #f1f1f1;
  }
}
</style>